// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1Q6ZD","name":"ConsentHeader_name__1QRu_","birthday":"ConsentHeader_birthday__3dQGZ","skeleton":"ConsentHeader_skeleton__2vy9H"};